import { render, staticRenderFns } from "./AddOrigin.vue?vue&type=template&id=0fb27d74&"
import script from "./AddOrigin.vue?vue&type=script&lang=js&"
export * from "./AddOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports